import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'scanner',
    loadComponent: () =>
      import('./features/scanner/scanner.component').then(m => m.ScannerComponent),
    canActivate: [authGuard]
  },
  {
    path: '',
    redirectTo: '/scanner',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/scanner'
  }
];
